import { toast } from "react-toastify";
import ErrorUtils from "../../utils/ApiUtils/ErrorUtils";
import { useMutation, useQueryClient } from "react-query";

import ExportTranslationCacheName from "../../utils/ExportTranslationCacheName";
import { deleteTranslation } from "../../api/deleteTranslation";

export function useDeleteTranslation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: deleteTranslation,
    onSuccess: (response) => {
      toast.success(" The selected translation has been deleted ");
      queryClient.invalidateQueries(ExportTranslationCacheName.getExportTranslation());
    },
    onError: (error) => {
      let errorMsg = ErrorUtils.getErrorMessage(error);
      toast.error(errorMsg);
      console.error("Error submitting form:", error);
    },
  });
}
